
seedWebApp.controller('EditContactsModalController', ['$scope', 'contact', '$uibModalInstance', 'ContactService', 'TranslationService','UserSettingService',
function ($scope, contact, $uibModalInstance, ContactService, TranslationService, UserSettingService) {

    $scope.listItem = contact;
    $scope.titleContactName = $scope.listItem.ContactName;
    $scope.translation = TranslationService.getActiveTranslation();
    $scope.loading = true;
    $scope.actualYear = (new Date()).getFullYear();

    ContactService.get(contact.ContactID).then( function (response) {
        $scope.loading = false;
        $scope.error = false;
        $scope.listItem = response.data;

        if ($scope.listItem.ContactGoals) {
            var yearsToAdd = [$scope.actualYear, $scope.actualYear + 1];
            $scope.listItem.ContactGoals = $scope.listItem.ContactGoals.filter(function (e) {
                var found = yearsToAdd.findIndex(function (year) {
                    return year == e.GoalYear;
                });
                if (found != -1) {
                    yearsToAdd.splice(found, 1);
                }
                return e.GoalYear <= $scope.actualYear + 1;
            });
            for (var i = 0; i < yearsToAdd.length; i++) {
                $scope.listItem.ContactGoals.push({ ContactID: $scope.listItem.ContactID, GoalYear: yearsToAdd[i] });
            }
            $scope.listItem.ContactGoals.sort(function (a, b) {
                return a.GoalYear - b.GoalYear;
            });
        }
    }, function errorFunc(errorDescription) {
        $scope.listItem = [];
        $scope.error = true;
        $scope.errorDescription = errorDescription;
    });


    $scope.savePermission = function () {
        $uibModalInstance.close($scope.listItem);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.contactTypes = [
        { Key: 'CLIENTE', Value: 'CLIENTE' },
        { Key: 'VENDEDOR', Value: 'VENDEDOR' },
        { Key: 'COMERCIAL', Value: 'COMERCIAL' }
    ];

    $scope.contactGroups = [
        { Key: 1, Value: 'CLIENTE NACIONAL' },
        { Key: 2, Value: 'CLIENTE INTERNACIONAL' },
    ];


    $scope.shippingScheduleCols = [
        { ColName: 'PO', IsActive: true },
        { ColName: 'Invoice', IsActive: true },
        { ColName: 'Patters', IsActive: true },
        { ColName: 'CustomerDate', IsActive: true },
        { ColName: 'PO Requested Shipment', IsActive: true },
        { ColName: 'Place of delivery', IsActive: true },
        { ColName: 'Port of Discharge', IsActive: true },
        { ColName: 'Loaded at the Mill', IsActive: true },
        { ColName: 'Vessel / VG', IsActive: true },
        { ColName: 'ActualShippingDate', IsActive: true },
        { ColName: 'ETA Port of Discharge', IsActive: true },
        { ColName: 'ETA Place of delivery', IsActive: true },
        { ColName: 'BL', IsActive: true },
        { ColName: 'Container', IsActive: true },
        { ColName: 'Booking', IsActive: true },
        { ColName: 'Shipping Company', IsActive: true },
    ];

    //$scope.userSearch = function () {
    //    console.log('userSearch');
    //};

    $scope.userSearch = function (query) {
        return UserSettingService.getUsersQuery(query)
            .then(function (response) {
                return response.data.map(function (item) {
                    return item;
                });
            })
            .catch(function (err) {
                console.error(err);
            });
    };
}]);
